import React, { useEffect, useState } from 'react';
import Header from '../../../components/maz-tu-info-bees/maz-tu-info-bees-admin/Header';
import BandButton from '../../../components/maz-tu-info-bees/maz-tu-info-bees-admin/BandButton';
import styles from './styles.module.scss';

import fetchAPI from './../../../utils/fetchAPI';
import { getVarConfig } from './../../../utils/environment';

const initialForm = { email: '', nombre: '' };

const AdminUsers = ({ setLoading, loading, handleToast }) => {
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [form, setForm] = useState(initialForm);
  const [editingId, setEditingId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const service = getVarConfig({ key: 'REACT_APP_ADMIN_USERS_ENDPOINT' }) || 'v1/MX/admin/users/admin';

  // Consultar usuarios
  const fetchUsers = async () => {
    setLoading(true);
    await fetchAPI({
      service,
      protocol: 'GET',
      params: {},
      callbackThen: (res) => setUsers(res.data || []),
      callbackError: () => handleToast('Error al cargar usuarios'),
    });
    setLoading(false);
  };

  useEffect(() => { fetchUsers(); }, []);

  // Crear o editar usuario
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const method = editingId ? 'PUT' : 'POST';
    const url = editingId ? `${service}/${editingId}` : service;
    await fetchAPI({
      service: url,
      protocol: method,
      params: form,
      callbackThen: () => {
        handleToast(editingId ? 'Usuario actualizado' : 'Usuario creado');
        setShowModal(false);
        setForm(initialForm);
        setEditingId(null);
        fetchUsers();
      },
      callbackError: () => handleToast('Error al guardar usuario'),
    });
    setLoading(false);
  };

  // Eliminar usuario
  const handleDelete = async () => {
    setLoading(true);
    await fetchAPI({
      service: `${service}/${deleteId}`,
      protocol: 'DELETE',
      params: {},
      callbackThen: () => {
        handleToast('Usuario eliminado');
        setShowDeleteModal(false);
        setDeleteId(null);
        fetchUsers();
      },
      callbackError: () => handleToast('Error al eliminar usuario'),
    });
    setLoading(false);
  };

  // Abrir modal para editar
  const handleEdit = (user) => {
    setForm({ email: user.email, nombre: user.nombre });
    setEditingId(user.id);
    setShowModal(true);
  };

  // Abrir modal para eliminar
  const handleDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  return (
    <div className={styles.container}>
      <Header title="Usuarios Admin" userName="Admin" back={false} />
      <div className={styles.body}>
        <BandButton title="Usuarios Admin" color="yellow" colorIcon="yellow" />
        <button className={styles.addBtn} onClick={() => { setShowModal(true); setForm(initialForm); setEditingId(null); }}>
          + Agregar Usuario
        </button>
        <table className={styles.table}>
          <thead>
          <tr>
            <th>Email</th>
            <th>Nombre</th>
            <th>Acciones</th>
          </tr>
          </thead>
          <tbody>
          {users.map(u => (
            <tr key={u.id}>
              <td>{u.email}</td>
              <td>{u.nombre}</td>
              <td>
                <button onClick={() => handleEdit(u)}>Editar</button>
                <button onClick={() => handleDeleteModal(u.id)} className={styles.deleteBtn}>Eliminar</button>
              </td>
            </tr>
          ))}
          </tbody>
        </table>

        {/* Modal Crear/Editar */}
        {showModal && (
          <div className={styles.modal}>
            <form className={`${styles.modalContent} ${styles.formGrid}`} onSubmit={handleSubmit}>
              <h3>{editingId ? 'Editar Usuario' : 'Agregar Usuario'}</h3>
              <label>Email
                <input
                  type="email"
                  value={form.email}
                  onChange={e => setForm({ ...form, email: e.target.value })}
                  required
                />
              </label>
              <label>Nombre
                <input
                  type="text"
                  value={form.nombre}
                  onChange={e => setForm({ ...form, nombre: e.target.value })}
                  required
                />
              </label>
              <div className={styles.modalActions}>
                <button type="submit" className={styles.addBtn}>
                  {editingId ? 'Actualizar' : 'Crear'}
                </button>
                <button type="button" onClick={() => setShowModal(false)}>
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Modal Eliminar */}
        {showDeleteModal && (
          <div className={styles.modal}>
            <div className={styles.modalContent}>
              <h3>¿Eliminar usuario?</h3>
              <div className={styles.modalActions}>
                <button onClick={handleDelete} className={styles.deleteBtn}>Eliminar</button>
                <button onClick={() => setShowDeleteModal(false)}>Cancelar</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminUsers;
